// Vendor
import { createAction, props } from '@ngrx/store';
export const setAlertObject = createAction('[Alerts App] Set Alert Object', props());
